module.exports = __webpack_public_path__ + "static/media/error.66c0cc23.svg";